import { render } from "./MatchPercentage.vue?vue&type=template&id=3ef98848&scoped=true&ts=true"
import script from "./MatchPercentage.vue?vue&type=script&lang=ts"
export * from "./MatchPercentage.vue?vue&type=script&lang=ts"

import "./MatchPercentage.vue?vue&type=style&index=0&id=3ef98848&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef98848"]])

export default __exports__